import { defineComponent as _defineComponent } from 'vue'
import { computed, withDefaults } from "vue";
import SvgPlus from "@/assets/icons/plus.svg";
import TrashButton from "@/components-UI/buttons/TrashButton.vue";
import BaseText from "@/components-UI/BaseText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseUpload',
  props: {
    value: { default: () => [] },
    placeholder: { default: 'Загрузить файл' },
    multiple: { type: Boolean, default: false },
    accept: null,
    limit: null,
    id: null,
    hideButtonAfterUpload: { type: Boolean },
    addNumbering: { type: Boolean }
  },
  emits: [
    'update:value',
    'change',
    'delete',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { value: File[] | [], placeholder: string, multiple: boolean, accept?: string, limit?: number, id?: string, hideButtonAfterUpload?: boolean, addNumbering?: boolean }




const uniqId: string = 'base-upload-' + Math.random().toString(36).substr(2, 9);

const isShowUploadContent = computed<boolean>(() => {
    return !props.hideButtonAfterUpload || !getFiles.value.length;
});

const getFiles = computed<File[] | []>(() => {
    return Array.isArray(props.value) ? props.value : [];
});

const handleUploadFile = (event: Event): void => {
    const target = event.target as HTMLInputElement;
    const preparedFiles = Array.from(target.files!);
    const files: File[] = preparedFiles;

    if (props.multiple && !!props.limit && typeof props.limit === 'number') {
        // ограничиваем выбор первыми limit файлами (splice(0, limit) отбрасывал их)
        files = files.slice(0, props.limit);
    }

    emits('update:value', files);
    emits('change', files);
    target.value = '';
};

const handleDeleteFile = (index: number): void => {
    // не мутируем проп: эмитим новый массив + delete(index), родитель обновит value
    const next = getFiles.value.filter((_, i) => i !== index);
    emits('update:value', next);
    emits('change', next);
    emits('delete', index);
};

return { __sfc: true,props, emits, uniqId, isShowUploadContent, getFiles, handleUploadFile, handleDeleteFile, SvgPlus, TrashButton, BaseText }
}

})